import http from '~/common/http';

let promises = {};

export default {

    // 获取省份数据
    getProvinces() {
        if (!promises['provinces']) {
            promises['provinces'] = http.get('/api/district/provinces');
        } 
        return promises['provinces'];
    },

    getCities(provinceId) {
        if (!promises['cities' + provinceId]) {
            promises['cities' + provinceId] = http.get('/api/district/cities', {
                params: {
                    provinceId: provinceId
                }
            });
        }
        return promises['cities' + provinceId];
    },

    getDists(cityId) {
        if (!promises['districts' + cityId]) {
            promises['districts' + cityId] = http.get('/api/district/districts', {
                params: {
                    cityId: cityId
                }
            });
        }
        return promises['districts' + cityId];
    },

    getInfo(id) {
        return http.get('/api/district/get-info', {
            params: {
                id: id
            }
        });
    },

    getList(params) {
        return http.get('/api/district/index', {
            params: params
        });
    },

    create(district) {
        return http.post('/api/district/create', district);
    },

    update(district) {
        return http.put('/api/district/update?id=' + district.id, district);
    },

    delete(districtId) {
        return http.delete('/api/district/delete?id=' + districtId);
    },


    getTreeList() {
        return http.get('/api/district/districts-tree');
    },
    getZujuanTreeList() {
        return http.get('/api/district/zujuan-districts-tree');
    },

    getCityTree() {
        return http.get('/api/district/city-tree');
    },
}


// WEBPACK FOOTER //
// ./src/services/district.js